<script setup>
import { computed, getCurrentInstance, onMounted, ref } from "vue";
import _ from "lodash";
import { RouterLink } from "vue-router";
import KSAPrimaryButton from "../../../../../components/ui-components/button/KSAPrimaryButton.vue";
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import adminMatchingService from "../../../services/matching/adminMatchingService";
import { usePageLoadingStore } from "../../../../../stores/pageLoading";
import { useAlertStore } from "../../../../../stores/alertStore";
const {$alert, $confirm} = useAlertStore();

const loaded = ref(false);
const loadingStore = usePageLoadingStore();
const { $desiredJob, $interests, $phoneNum, $number, $pageListBoardNo, $yyyymmddHHmmss } = getCurrentInstance().appContext.config.globalProperties;

const interests = ref($interests);                // 관심 카테고리
const desiredJob = ref($desiredJob);              // 직무

const props = defineProps({
  corporation: {
    type: Object,
    default: () => ({}),
  },
});

const corporation = computed(() => props.corporation || {});
const corpEmpList = ref([]);

const desiredJobListRef = ref(null);        // 직무
const interestsListRef2 = ref(null);        // 관심 카테고리


const searchOpen = ref(true);
const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(0);
const totalCount = ref(0);

const checkMasterYn = ref(false);   // 마스터 회원

const searchInput2 = ref({ // 재직자 가입 현황 tab 검색조건
  desiredJobList: ['회로/시스템 설계','장비 운영/유지보수/개선','장비/부품 개발','소재 개발 및 평가','공정 개발 및 평가','패키지 개발','제품 평가 및 분석','반도체 SW 개발','기타'],
  interestsList: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
  sex: '00',
  corpMasterYn: false,
  searchType: 'name', // code 회원코드,name 이름, id 아이디, email 이메일
  searchInput: '',
  searchDurationGb: 'C', // (L 최근 접속일 C 가입일)
  searchDurationType: 'all',
  startYmd: '',
  endYmd: '',
});

// 재직자 가입 현황 조회
const retrieveCorpEmpList = () => {
  let paramObj = {
    corpId: corporation.value.corpId,
    searchDesiredJobs: _.map(searchInput2.value.desiredJobList).join(','),
    searchInterests: _.map(searchInput2.value.interestsList).join(','),
    searchSex: searchInput2.value.sex,
    searchCorpMasterYn: searchInput2.value.corpMasterYn ? 'Y' : 'N',
    searchType: searchInput2.value.searchType,
    searchInput: searchInput2.value.searchInput,
    searchDurationGb: searchInput2.value.searchDurationGb,
    startYmd: searchInput2.value.searchDurationType === 'all' ? '' : searchInput2.value.startYmd,
    endYmd: searchInput2.value.searchDurationType === 'all' ? '' : searchInput2.value.endYmd,
    pageNumber: currentPage.value,
    size: pageSize.value,
  }
  //loadingStore.loading = true;
  loaded.value = false;
  adminMatchingService.retrieveCorpEmpList(paramObj)
      .then(async (res) => {
        //loadingStore.loading = false;
        loaded.value = true;
        // console.log(res);
        if (res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          corpEmpList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        } else {
        }
      }).catch((res) => {
    console.log(res);
    //loadingStore.loading = false;
    loaded.value = true;
  });
}


// 마스터 권한 변경
const changeAdminCorpMasterYn = async (userId, masterYn) => {
  // 마스터가 있을 경우, 마스터 권한 부여 못함.
  if(masterYn === 'Y') {
    await checkCorpMasterYn();
    if(checkMasterYn.value) {
      $alert("이미 마스터 권한을 가진 회원이 있습니다.");
      return -1;
    }
  }

  let ok;
  if(masterYn === 'Y') {
    ok = await $confirm(["회원에게 마스터 권한을 부여할까요?", "마스터 회원은 일자리/장비 매칭을 할 수 있습니다."], "권한 부여");
  } else {
    ok = await $confirm(["마스터 권한을 취소 시킬까요?", "취소하더라도 매칭 내역 정보는 삭제되지 않습니다."], "권한 취소");
  }

  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      userId: userId,
      masterYn: masterYn,
    }
    loadingStore.loading = true;
    adminMatchingService.updateAdminCorpMasterYn(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if (res.data.code.toLowerCase() === 'success') {
            $alert(["마스터 권한 변경을 하였습니다."]);
            retrieveCorpEmpList();
          } else {
            console.log(res);
          }
        }).catch( (res) => {
      console.log(res)
    });
  }
}

// 해당 기업에 마스터가 있는지 확인
const checkCorpMasterYn = async () => {
  loadingStore.loading = true;
  await adminMatchingService.retrieveMasterYnCount(corporation.value.corpId)
      .then( (res) => {
        loadingStore.loading = false;
        if (res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          checkMasterYn.value = (result > 0);
        } else {
        }
      }).catch( (res) => {
        console.log(res);
      });
}

const pageSizeGroup = ref([
  { label:'10개씩 보기', value: '10' },
  { label:'30개씩 보기', value: '30' },
  { label:'50개씩 보기', value: '50' },
  { label:'100개씩 보기', value: '100' },
])

// START : 재직자 가입 현황 TAB
// 검색조건 - 성별. 재직자 가입 현황 tab
const sexGroup = ref([
  { label:'전체', value: '00' },
  { label:'남자', value: '01' },
  { label:'여자', value: '02' },
]);

// 검색조건 - 기간 (C 가입일, C 최근 접속일). 재직자 가입 현황 tab.
const searchDurationGbGroup = ref([
  { label:'가입일', value: 'C' },
  { label:'최근 접속일', value: 'L' },
])

// 검색조건 - 날짜검색기준 (all 모든 기간, term 기간 검색). 재직자 가입 현황 tab
const searchDurationTypeGroup = ref([
  { label:'모든 기간', value: 'all' },
  { label:'기간 검색', value: 'term' },
])

// 검색조건 - 검색기준 (재직자명, 아이디, 핸드폰번호 뒷4자리, 이메일). 재직자 가입 현황 tab
const searchTypeGroup2 = ref([
  { label:'재직자명', value: 'name', placeholder: '이름을 입력해 주세요.' },
  { label:'아이디', value: 'id', placeholder: '아이디를 입력해 주세요.' },
  { label:'핸드폰번호', value: 'phone', placeholder: '"-"를 제외한 핸드폰번호 뒷4자리를 입력해 주세요.' },
  { label:'이메일', value: 'email', placeholder: '이메일을 입력해 주세요.' },
]);
const searchInputPlaceholder2 = computed(()=>{
  const option = _.find(searchTypeGroup2.value, { value: searchInput2.value.searchType });
  if(option) {
    return option.placeholder;
  } else {
    return '';
  }
});

// 페이지 선택
const onSelectPage = (pageNo) => {
  currentPage.value = pageNo;
  retrieveCorpEmpList();
}

// 검색조건 - 페이지 사이즈 변경. 10,30,50,100
const onSelectPageSize = (option) => {
  pageSize.value = option.value;
  currentPage.value = 1;

  retrieveCorpEmpList();
}

// 검색조건 - 검색기준 매핑
const onSelectSearchTypeGroup = (option) => {
  searchInput2.value.searchType = option.value;
}

// 검색조건 - 기간 매핑(C:가입일, L:최근 접속일), 재직자 가입 현황 tab
const onSelectSearchDurationGbGroup = (option) => {
  searchInput2.value.searchDurationGb = option.value;
}

// 검색조건 - '초기화' 버튼
const clearSearchInput = () => {
  searchInput2.value = {
    desiredJobList: ['회로/시스템 설계','장비 운영/유지보수/개선','장비/부품 개발','소재 개발 및 평가','공정 개발 및 평가','패키지 개발','제품 평가 및 분석','반도체 SW 개발','기타'],
    interestsList: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
    sex: '00',
    corpMasterYn: false,
    searchType: 'name', // code 회원코드,name 이름, id 아이디, email 이메일
    searchInput: '',
    searchDurationGb: 'C', // (C 가입일 L 최근 접속일 )
    searchDurationType: 'all',
    startYmd: '',
    endYmd: '',
  }
  desiredJobListRef.value.initOptions();
  interestsListRef2.value.initOptions();
}

// 검색조건 - '검색' 버튼
const onClickSearch = () => {
  currentPage.value = 1;
  retrieveCorpEmpList();
}

onMounted(()=>{
  retrieveCorpEmpList();
})

</script>
<template>
  <!-- s: 검색 -->
  <div class="filter-wrap" :class="{'open': searchOpen}">
    <p @click="searchOpen = !searchOpen">검색</p>
    <div class="filter">
      <dl >
        <dt style="display:block;"><span>직무</span><br><small style="font-weight: normal;">복수 선택 가능</small></dt>
        <dd>
          <KSACheckBoxGroup
              ref="desiredJobListRef"
              className="mr-md"
              name="desiredJobList"
              v-model="searchInput2.desiredJobList"
              :options="desiredJob" />
        </dd>
      </dl>
      <dl>
        <dt style="display:block;"><span>관심 카테고리</span><br><small style="font-weight: normal;">복수 선택 가능</small></dt>
        <dd>
          <KSACheckBoxGroup
              ref="interestsListRef2"
              className="mr-md"
              name="interestsList"
              v-model="searchInput2.interestsList"
              :options="interests" />
        </dd>
      </dl>
      <dl>
        <dt>성별</dt>
        <dd>
          <template v-for="group in sexGroup" key="item.value" >
            <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput2.sex" :value="group.value" />
          </template>
        </dd>
      </dl>
      <dl>
        <dt>마스터 회원</dt>
        <dd>
          <KSACheckBox label="마스터 회원 보기" v-model="searchInput2.corpMasterYn" />
        </dd>
      </dl>
      <!-- 재직자명,아이디,핸드폰번호뒷자리,이메일 검색 -->
      <dl>
        <dt>
          <KSASelect :options="searchTypeGroup2" class="select" @selectOption="onSelectSearchTypeGroup"/>
        </dt>
        <dd>
          <KSAInput class="text-box" v-model="searchInput2.searchInput" :placeholder="searchInputPlaceholder2" />
        </dd>
      </dl>
      <!-- 가입일,최근 접속일,모든기간,기간검색 -->
      <dl>
        <dt>
          <KSASelect ref="searchDurationGbRef2" :options="searchDurationGbGroup" class="select" @selectOption="onSelectSearchDurationGbGroup"/>
        </dt>
        <dd class="text-box">
          <div class="grid">
            <template v-for="group in searchDurationTypeGroup" key="item.value" >
              <KSARadioButton class="mr-md" name="searchDurationGb2" :label="group.label" v-model="searchInput2.searchDurationType" :value="group.value" />
            </template>
            <div style="display: inline-block;" v-show="searchInput2.searchDurationType !== 'all'">
              <KSADatepickerTerms
                  :startDate="searchInput2.startYmd"
                  :endDate="searchInput2.endYmd"
                  @update:startDate="(value)=> searchInput2.startYmd = value"
                  @update:endDate="(value)=> searchInput2.endYmd = value"
              />
            </div>
          </div>
        </dd>
      </dl>
      <div class="btn-wrap">
        <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
        <KSAPrimaryButton text="검색" @click="onClickSearch" />
      </div>
    </div>
  </div>
  <!-- e: 검색 -->
  <div class="list-top">
    <p>전체 <span>{{ $number(totalCount)}}</span>명</p>
    <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
  </div>
  <div class="table-form">
    <table class="horizontal" v-if="corpEmpList !== null">
      <tr>
        <th>NO</th>
        <th>가입일</th>
        <th>최근 접속일</th>
        <th>재직자명</th>
        <th>아이디</th>
        <th>핸드폰번호</th>
        <th>이메일</th>
        <th>마스터구분</th>
        <th>마스터 권한 변경</th>
      </tr>
      <tr v-for="corpEmp in corpEmpList">
        <td>{{ corpEmp.boardNo }}</td>
        <td>{{ $yyyymmddHHmmss(corpEmp.createDate) }}</td>
        <td>{{ $yyyymmddHHmmss(corpEmp.lastLoginDate) }}</td>
        <td class="link text">
          <RouterLink :to="{name:'MemberDetail', params:{id: corpEmp.userId}}">{{ corpEmp.userName }}</RouterLink>
        </td>
        <td>{{ corpEmp.userLoginId }}</td>
        <td>{{ $phoneNum(corpEmp.phoneNum) }}</td>
        <td>{{ corpEmp.email }}</td>
        <td>
          <span v-if="corpEmp.corpMasterYn === 'Y'">마스터</span>
          <span v-else>-</span>
        </td>
        <td>
          <span v-if="corpEmp.corpMasterYn === 'Y'" @click="changeAdminCorpMasterYn(corpEmp.userId, '')" class="link text" style="color: red;">[마스터 권한 취소]</span>
          <span v-else @click="changeAdminCorpMasterYn(corpEmp.userId, 'Y')" class="link text">[마스터 권한 부여]</span>
        </td>
      </tr>
    </table>
    <div class="result-none" v-if="corpEmpList.length === 0">
      가입한 재직자가 없습니다.
    </div>
    <Paginate
        v-if="corpEmpList.length > 0"
        v-model="currentPage"
        :page-count="totalPages"
        :click-handler="onSelectPage"
    />
  </div>
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
</style>